/* Ride3 globe homepage. Reads its links and settings from the DOM written by sections/ride3-globe.liquid. */
(function () {
  var MOBILE_MAX = 700;           // keep in sync with ride3-globe.css
  var HOLD_MS = 900;              // logo stays big and centred
  var FOOTER_H = 44;
  var TILT = 0.38, CT = Math.cos(TILT), ST = Math.sin(TILT);
  var state = null;               // the running instance, so a theme-editor reload can replace it

  /* Centres for n equally spaced boxes down one side: centred on cy, spread over about the globe's height (1.15R),
     and never closer together than a tallest box plus the gap. Same order as the editor. */
  function evenCentres(n, cy, R, maxH, gap) {
    var out = [], pitch = n > 1 ? Math.max(1.15 * R / (n - 1), maxH + gap) : 0;
    for (var i = 0; i < n; i++) out.push(cy + (i - (n - 1) / 2) * pitch);
    return out;
  }

  /* Spreads boxes that would overlap. items: [{want: preferred centre y, h: height}] in editor order.
     Boxes keep their order, stay as close to `want` as they can, and sit between lo and hi with `gap` between them.
     Returns the centre y of each box, in the same order as items. If the boxes cannot fit between lo and hi
     they start at lo and run past hi (the caller then makes the page taller). */
  function spread(items, lo, hi, gap) {
    var order = items.map(function (it, i) { return i; }).sort(function (a, b) { return (items[a].want - items[b].want) || (a - b); });
    function clamp(c) { c.top = Math.min(c.top, hi - c.h); c.top = Math.max(c.top, lo); }
    var clusters = order.map(function (i) { var c = { ids: [i], h: items[i].h, top: items[i].want - items[i].h / 2 }; clamp(c); return c; });
    var merged = true;
    while (merged) {
      merged = false;
      clusters.sort(function (a, b) { return a.top - b.top; });
      for (var k = 0; k < clusters.length - 1; k++) {
        var a = clusters[k], b = clusters[k + 1];
        if (a.top + a.h + gap > b.top + 1e-6) {
          var ids = a.ids.concat(b.ids), y = 0, sum = 0, h;
          ids.forEach(function (i) { sum += items[i].want - items[i].h / 2 - y; y += items[i].h + gap; });
          h = y - gap;
          var c = { ids: ids, h: h, top: sum / ids.length }; clamp(c);
          clusters.splice(k, 2, c); merged = true; break;
        }
      }
    }
    var out = new Array(items.length);
    clusters.forEach(function (c) { var y = c.top; c.ids.forEach(function (i) { out[i] = y + items[i].h / 2; y += items[i].h + gap; }); });
    return out;
  }

  function init() {
    if (state) state.stop();
    var root = document.getElementById('ride3-globe');
    var data = window.RIDE3_GLOBE || { pts: [], edges: [] };      // links still work if the globe data fails to load
    if (!root) return;
    state = start(root, data);
  }

  function start(root, data) {
    var pts = data.pts, edges = data.edges;
    var cv = root.querySelector('.rg-canvas'), ctx = cv.getContext('2d');
    var svg = root.querySelector('.rg-lines'), hdr = root.querySelector('.rg-header'), logo = root.querySelector('.rg-logo');
    var links = Array.prototype.slice.call(root.querySelectorAll('.rg-link'));
    var spin = (parseFloat(root.dataset.spin) || 7) * 0.0001;           // radians per 60fps frame
    var flashRate = Math.max(1, parseFloat(root.dataset.flash) || 5);
    var evenSpacing = root.dataset.even !== 'false';              // on unless the editor switched it off
    var W, H, R, cx, cy, lastW = 0, lastH = 0, yaw = 0, raf = 0, stopped = false, openLink = null;
    var timers = [], t0 = performance.now();

    /* ---------- layout: place links, draw lines to the globe ---------- */
    function byIndex(a, b) { return a.dataset.index - b.dataset.index; }
    function bySide(a, b) { return (a.dataset.side === b.dataset.side ? 0 : a.dataset.side === 'left' ? -1 : 1) || byIndex(a, b); }

    // Positions everything for a page height Hc. Returns the height the content really needs and the globe radius used.
    function place(Hc, narrow, top, fixedR) {
      var html = '', R0, need;
      if (!narrow) {
        R0 = fixedR || Math.max(90, Math.min(W * 0.22, (Hc - top - FOOTER_H - 56) / 2));
        R = R0; cx = W / 2; cy = top + (Hc - top - FOOTER_H - 30) / 2;
        var m = 16, gap = 28, GAP = 12, sides = { left: [], right: [] }, stack = 0, n = 0;
        links.forEach(function (l) {
          var left = l.dataset.side === 'left', pos = (parseFloat(l.dataset.pos) || 0) / 100;
          var room = left ? cx - R - gap - m : W - m - (cx + R + gap);
          l.style.left = '0px'; l.style.top = '0px'; l.style.maxWidth = Math.max(90, room) + 'px';
          sides[left ? 'left' : 'right'].push({ l: l, left: left, want: cy + pos * R * 1.15, h: l.offsetHeight, w: l.offsetWidth });
        });
        if (evenSpacing) ['left', 'right'].forEach(function (s) {
          var arr = sides[s], maxH = 0;
          arr.forEach(function (it) { maxH = Math.max(maxH, it.h); });
          evenCentres(arr.length, cy, R, maxH, GAP).forEach(function (c, i) { arr[i].want = c; });
        });
        ['left', 'right'].forEach(function (s) { var sum = -GAP; sides[s].forEach(function (it) { sum += it.h + GAP; }); stack = Math.max(stack, sum); });
        if (evenSpacing) ['left', 'right'].forEach(function (s) {
          var arr = sides[s], maxH = 0; arr.forEach(function (it) { maxH = Math.max(maxH, it.h); });
          if (arr.length > 1) stack = Math.max(stack, (arr.length - 1) * Math.max(1.15 * R / (arr.length - 1), maxH + GAP) + maxH);
        });
        need = Math.max(top + 2 * Math.max(90, R0) + FOOTER_H + 56, top + stack + FOOTER_H + 24);   // tall stacks make the page taller
        ['left', 'right'].forEach(function (s) {
          var arr = sides[s], ys = spread(arr, top, Hc - FOOTER_H - 12, GAP);
          arr.forEach(function (it, i) {
            var y = ys[i], ex = it.left ? Math.max(m + it.w, cx - R - gap) : Math.min(W - m - it.w, cx + R + gap);
            it.l.style.left = (it.left ? ex - it.w : ex) + 'px'; it.l.style.top = (y - it.h / 2) + 'px';
            var yy = Math.min(cy + R * 0.85, Math.max(cy - R * 0.85, y));                      // the dot always lands on the globe
            var tx = cx + (it.left ? -1 : 1) * Math.sqrt(Math.max(0, R * R - (yy - cy) * (yy - cy))) * 0.62;
            html += dot('<line x1="' + ex + '" y1="' + y + '" x2="' + tx + '" y2="' + yy + '"/>', tx, yy, n++);
          });
        });
      } else {
        var bw = Math.min(160, W * 0.44), bx = W - 16 - bw, gapY = 8, hs = [], listH = -gapY;
        links.forEach(function (l) { l.style.maxWidth = 'none'; l.style.width = bw + 'px'; l.style.height = ''; l.style.left = bx + 'px'; l.style.top = '0px'; var h = Math.max(44, l.offsetHeight); hs.push(h); listH += h + gapY; });
        R0 = fixedR || Math.max(66, Math.min(W * 0.34, (Hc - top - FOOTER_H - listH - 44) / 2));
        need = top + 2 * Math.max(66, R0) + 6 + 30 + listH + 14 + FOOTER_H;
        R = R0; cx = W / 2; cy = top + R + 6;
        var y = cy + R + 30, count = links.length, xs = Math.min(bx - 14, cx + R * 0.8), xe = cx - R * 0.85, step = count > 1 ? (xs - xe) / (count - 1) : 0;
        links.forEach(function (l, n) {
          var h = hs[n], mid = y + h / 2; l.style.height = h + 'px'; l.style.top = y + 'px'; y += h + gapY;
          var gx = xs - n * step, ty = cy + Math.sqrt(Math.max(0, R * R - (gx - cx) * (gx - cx)));
          html += dot('<path d="M' + bx + ' ' + mid + ' H' + gx + ' V' + ty + '"/>', gx, ty, n);
        });
      }
      svg.innerHTML = html;
      return { need: need, R: R0 };
    }

    function layout() {
      var d = window.devicePixelRatio || 1;
      closeMenu();
      root.classList.remove('rg-scroll'); root.style.height = '';
      W = root.clientWidth; H = root.clientHeight;
      var narrow = W <= MOBILE_MAX && !(W > H && W >= 560);
      root.classList.toggle('rg-narrow', narrow);
      links.sort(narrow ? byIndex : bySide);                               // keyboard order follows what is on screen
      links.forEach(function (l) { l.parentNode.appendChild(l); l.style.width = ''; l.style.height = ''; });
      var top = hdr.offsetHeight + hdr.offsetTop + 10;
      var r = place(H, narrow, top);
      if (r.need > H) {                                                    // does not fit: let the page scroll instead of hiding links
        H = Math.ceil(r.need); root.classList.add('rg-scroll'); root.style.height = H + 'px';
        place(H, narrow, top, r.R);
      }
      cv.width = W * d; cv.height = H * d; ctx.setTransform(d, 0, 0, d, 0, 0);
      lastW = window.innerWidth; lastH = window.innerHeight;
    }
    function dot(line, x, y, n) {
      return line + '<circle class="t" cx="' + x + '" cy="' + y + '" r="3.5"/><circle class="r" cx="' + x + '" cy="' + y + '" r="9" style="animation-delay:' + (n * 0.45) + 's"/>';
    }

    /* ---------- dropdowns ---------- */
    function closeMenu() {
      if (!openLink) return;
      var btn = openLink.querySelector('.rg-btn'), menu = openLink.querySelector('.rg-menu');
      openLink.classList.remove('rg-open'); btn.setAttribute('aria-expanded', 'false'); menu.hidden = true; menu.classList.remove('rg-up'); menu.style.left = menu.style.right = '';
      openLink = null;
    }
    function openMenu(link) {
      closeMenu();
      var btn = link.querySelector('.rg-btn'), menu = link.querySelector('.rg-menu');
      link.classList.add('rg-open'); btn.setAttribute('aria-expanded', 'true'); menu.hidden = false; openLink = link;
      var left = link.dataset.side === 'left';
      menu.style.left = left ? '' : '0'; menu.style.right = left ? '0' : '';
      var r = menu.getBoundingClientRect();
      if (r.bottom > H - FOOTER_H) menu.classList.add('rg-up');
      r = menu.getBoundingClientRect();
      var shift = r.left < 8 ? 8 - r.left : (r.right > W - 8 ? (W - 8) - r.right : 0);
      if (shift) { menu.style.right = ''; menu.style.left = ((parseFloat(getComputedStyle(menu).left) || 0) + shift) + 'px'; }
    }
    links.forEach(function (l) {
      if (!l.dataset.menu) return;
      l.querySelector('.rg-btn').addEventListener('click', function (e) { e.stopPropagation(); if (openLink === l) closeMenu(); else openMenu(l); });
    });
    function onDocClick(e) { if (openLink && !openLink.contains(e.target)) closeMenu(); }
    function onKey(e) { if (e.key === 'Escape' && openLink) { var b = openLink.querySelector('.rg-btn'); closeMenu(); b.focus(); } }
    document.addEventListener('click', onDocClick); document.addEventListener('keydown', onKey);

    /* ---------- drawing ---------- */
    function rot(v, c, s) { var x = v[0] * c + v[2] * s, z = -v[0] * s + v[2] * c; return [x, v[1] * CT - z * ST, v[1] * ST + z * CT]; }
    var flashes = [], nextFlash = 0, vt = 0, last = 0;
    function frame(now) {
      if (stopped) return;
      var dt = last ? now - last : 0; last = now; vt += dt;
      yaw += spin * dt / 16.667;
      if (pts.length && vt > nextFlash) { flashes.push({ i: (Math.random() * pts.length) | 0, t0: vt, life: 1400 + Math.random() * 900 }); nextFlash = vt + (180 + Math.random() * 320) * 5 / flashRate; }
      var c = Math.cos(yaw), s = Math.sin(yaw), P = pts.map(function (v) { return rot(v, c, s); }), n, i;
      ctx.clearRect(0, 0, W, H);
      ctx.lineWidth = 1; ctx.strokeStyle = 'rgba(255,255,255,.10)';
      [1.18, 1.38].forEach(function (k, j) { ctx.beginPath(); ctx.ellipse(cx, cy, R * k * (j ? 1.12 : 1), R * k * 0.34, -0.32 + j * 0.1, 0, 6.283); ctx.stroke(); });
      for (n = 0; n < edges.length; n++) {
        var a = P[edges[n][0]], b = P[edges[n][1]], z = (a[2] + b[2]) / 2;
        ctx.strokeStyle = 'rgba(255,255,255,' + (z > 0 ? 0.12 + 0.45 * z : 0.04) + ')';
        ctx.beginPath(); ctx.moveTo(cx + a[0] * R, cy - a[1] * R); ctx.lineTo(cx + b[0] * R, cy - b[1] * R); ctx.stroke();
      }
      for (n = 0; n < P.length; n++) {
        var p = P[n]; ctx.fillStyle = 'rgba(255,255,255,' + (p[2] > 0 ? 0.45 + 0.45 * p[2] : 0.08) + ')';
        ctx.beginPath(); ctx.arc(cx + p[0] * R, cy - p[1] * R, p[2] > 0 ? 1.7 : 0.9, 0, 6.283); ctx.fill();
      }
      ctx.strokeStyle = 'rgba(255,255,255,.65)'; ctx.beginPath(); ctx.arc(cx, cy, R, 0, 6.283); ctx.stroke();
      for (i = flashes.length - 1; i >= 0; i--) {
        var f = flashes[i], age = (vt - f.t0) / f.life;
        if (age >= 1) { flashes.splice(i, 1); continue; }
        var q = P[f.i]; if (q[2] <= 0.05) continue;
        var al = Math.sin(age * Math.PI), x = cx + q[0] * R, y = cy - q[1] * R, r = 6 + 22 * al;
        var g = ctx.createRadialGradient(x, y, 0, x, y, r); g.addColorStop(0, 'rgba(255,255,255,' + al + ')'); g.addColorStop(1, 'rgba(255,255,255,0)');
        ctx.fillStyle = g; ctx.beginPath(); ctx.arc(x, y, r, 0, 6.283); ctx.fill();
        ctx.fillStyle = '#fff'; ctx.beginPath(); ctx.arc(x, y, 1.5 + 2.5 * al, 0, 6.283); ctx.fill();
      }
      raf = requestAnimationFrame(frame);
    }

    /* ---------- intro: big centred logo, then shrink to the top while everything else fades in ---------- */
    function logoToCentre() {
      var r = logo.getBoundingClientRect(), k = Math.min(window.innerWidth * 0.62, 460) / r.width;
      logo.style.transform = 'translate(' + (window.innerWidth / 2 - (r.left + r.width / 2)) + 'px,' + (window.innerHeight / 2 - (r.top + r.height / 2)) + 'px) scale(' + k + ')';
      logo.style.opacity = 1;
    }
    function play() {
      timers.push(setTimeout(function () { logo.classList.add('rg-moving'); logo.style.transform = 'none'; root.classList.remove('rg-pending'); }, Math.max(0, HOLD_MS - (performance.now() - t0))));
    }

    function onResize() {                      // ignore small height-only changes (phone address bar hiding while scrolling)
      if (window.innerWidth === lastW && Math.abs(window.innerHeight - lastH) < 150) return;
      layout();
    }
    window.addEventListener('resize', onResize);
    layout();
    var decoded = logo.decode ? logo.decode().catch(function () {}) : Promise.resolve();
    var ready = Promise.race([decoded, new Promise(function (r) { setTimeout(r, 1500); })]);   // never wait on a slow logo
    ready.then(function () {
      if (stopped) return;
      layout(); logoToCentre(); raf = requestAnimationFrame(frame); play();
    });

    return {
      stop: function () {
        stopped = true; cancelAnimationFrame(raf); timers.forEach(clearTimeout);
        window.removeEventListener('resize', onResize); document.removeEventListener('click', onDocClick); document.removeEventListener('keydown', onKey);
      }
    };
  }

  if (typeof module !== 'undefined' && module.exports) module.exports = { spread: spread, evenCentres: evenCentres };   // for the tests
  if (typeof document === 'undefined') return;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);   // theme editor re-renders the section
})();
